export default "__VITE_ASSET__tgcT773b__"